import DocsCreateCarrier from './styled';

export default DocsCreateCarrier;
